import { api, useApiQuery } from "../../api";
import { useAuthenticatedSession } from "../../session";
import { PageHeader } from "../../shell";
import { EquipeMembres, membresEntreprise } from "../equipe/EquipeMembres";
import { FeuillesDestinataires } from "./FeuillesDestinataires";
import { ParametresOnglets } from "./ParametresOnglets";

/** L'équipe de l'entreprise, pour ses administrateurs, et qui valide les feuilles. */
export function EquipePage() {
  const { user, company } = useAuthenticatedSession();
  const membres = useApiQuery((o) => (company ? api.listCompanyMembers(company.id, o) : Promise.resolve(null)), [company?.id]);
  if (company === null) {
    return null;
  }
  return (
    <>
      <PageHeader
        eyebrow="Paramètres"
        title="Équipe"
        description="Qui accède au portefeuille de l'entreprise, avec quel rôle. Un administrateur gère l'équipe et la marque ; un membre commande et consulte."
      />
      <ParametresOnglets />
      <EquipeMembres
        membres={membresEntreprise(company.id)}
        roles={["admin", "member"]}
        selfUserId={user.id}
        scopeKey={company.id}
      />
      {membres.data !== null && <FeuillesDestinataires companyId={company.id} membres={membres.data.users} />}
    </>
  );
}
